import { IIconBase } from '..'

const trashIcon = ({
  color = '#333752',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6128_7895)'>
        <rect width={width} height={height} fill='white' fillOpacity='0.01' />
        <path
          d='M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.66675 3.31301L5.81341 2.43967C5.92008 1.80634 6.00008 1.33301 7.12675 1.33301H8.87341C10.0001 1.33301 10.0867 1.83301 10.1867 2.44634L10.3334 3.31301'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.5667 6.09375L12.1334 12.8071C12.06 13.8537 12 14.6671 10.14 14.6671H5.86002C4.00002 14.6671 3.94002 13.8537 3.86668 12.8071L3.43335 6.09375'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.88672 11H9.10672'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.33325 8.33301H9.66659'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6128_7895'>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default trashIcon
